<template>
	<div class="position-fixed all-0 container width-5">
        <span class="loader-11"> </span>
    </div>
</template>
<script>
	export default{}
</script>